// @flow strict
import React from 'react';
import { Link } from 'gatsby';
import Helmet from 'react-helmet';
import { withPrefix } from 'gatsby';
import type { Node as ReactNode } from 'react';
import { useSiteMetadata } from '../../hooks';
import styles from './Layout.module.scss';
import '../../styles/OnSiteSearch.css';
import { OnSiteSearch } from '../Search/OnSiteSearch';
import '@fontsource/dotgothic16';

type Props = {
  children: ReactNode,
  title: string,
  description?: string,
  socialImage? :string
};

const Layout = ({
  children,
  title,
  description,
  socialImage
}: Props) => {
  const { author, url } = useSiteMetadata();
  const metaImage = socialImage != null ? socialImage : author.photo;
  const metaImageUrl = url + withPrefix(metaImage);

  return (
    <>
    <OnSiteSearch />
    <h2 className={styles['layout__inner']}>
      <Link className={styles['layout__body']} to="/">otsunekoの日常</Link>
    </h2>
    <div className={styles.layout}>
      <Helmet>
        <html lang="ja" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:site_name" content={title} />
        <meta property="og:image" content={metaImageUrl} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={metaImageUrl} />
        <meta name="google-site-verification" content={process.env.GOOGLE_SITE_VERIFICATION} />
      </Helmet>
      {children}
    </div>
    </>
  );
};

export default Layout;
